import React, { Dispatch, SetStateAction } from 'react';
import ErrorStep from './ErrorStep';
import SuccessStep from './SuccessStep';
import { SmartPayCustomerType } from '../../../../types';

interface Props {
    errorCode: string | null;
    setErrorCode: Dispatch<SetStateAction<string | null>>;
    back: () => void;
    onDialogClose: () => void;
    refetchState?: () => void;
    inMarket?: boolean;
    email: string;
    customerType: SmartPayCustomerType;
}

const InformationSentStep = ({
    errorCode,
    setErrorCode,
    back,
    onDialogClose,
    refetchState,
    inMarket,
    email,
    customerType,
}: Props) => {
    if (errorCode)
        return <ErrorStep errorCode={errorCode} setErrorCode={setErrorCode} onDialogClose={onDialogClose} back={back} />;

    return (
        <SuccessStep
            onDialogClose={onDialogClose}
            refetchState={refetchState}
            inMarket={inMarket}
            email={email}
            customerType={customerType}
        />
    );
};

export default InformationSentStep;
